import Modal from 'react-modal'
import IconAlertYellow from '../../../assets/icons/ico-alert-yellow.png'
import { Container } from './styles'

const ModalInfo = ({ visible, close, content }) => {
  return (
    <Container>
      <Modal
        isOpen={visible}
        onRequestClose={close}
        overlayClassName="react-modal-overlay"
        className="react-modal-content-alert"
      >
        <div className="react-modal-protocol-content">
          <div className="react-modal-alert">
            <img src={IconAlertYellow} alt="icone de alerta" />
          </div>
          <h3>{content?.title}</h3>
          <div className="react-modal-buttons">
            <button onClick={close} type="button">Ok</button>
          </div>
        </div>
      </Modal>

    </Container>
  )
}

export default ModalInfo
